import { Container, Heading, Link, Text } from "@chakra-ui/react";

export function meta() {
  return [
    {
      title: "Privacy Policy - Car Crushers",
    },
  ];
}

export default function () {
  return (
    <Container maxW="container.lg" pb="8vh" pt="4vh" textAlign="start">
      <Heading>Privacy Policy</Heading>
      <br />
      <Text>Last Updated: 2024-12-11</Text>
      <br />
      <hr />
      <br />
      <Heading size="lg">Information We Collect</Heading>
      <br />
      <ul>
        <li>
          <strong>Discord Profile Information</strong>: We receive account
          information from Discord, Inc. when you sign in such as your username,
          discriminator, avatar, and banner in order to authenticate you and
          authorize requests. A list of information available can be found at{" "}
          <Link
            color="#646cff"
            href="https://discord.com/developers/docs/resources/user"
            target="_blank"
          >
            Discord's Developer Portal
          </Link>
          .
        </li>
        <li>
          <strong>Email Addresses</strong>: We receive your email address from
          your Discord account in order to allow us to contact you as necessary.
        </li>
        <li>
          <strong>Member Information from Our Discord Server</strong>: We
          receive a list of your roles within our Discord Server in order to
          determine your ability to access certain parts of this site.
        </li>
        <li>
          <strong>Error Reports</strong>: We collect error reports to aid in
          fixing bugs and ensuring site stability.
        </li>
        <li>
          <strong>Uploaded Files and Reports</strong>: We store uploaded files
          and user reports to aid in moderating exploiters from Car Crushers 2.
        </li>
        <li>
          <strong>Appeals</strong>: We store appeal requests to review them.
        </li>
      </ul>
      <br />
      <Heading size="lg">
        Legal Basis for Processing of Your Personal Data
      </Heading>
      <br />
      <ul>
        <li>
          <strong>To fulfill contractual commitments</strong>: E.g allow you to
          use the site as intended.
        </li>
        <li>
          <strong>Legitimate interests</strong>: In some cases, we continue to
          process data on the grounds that our legitimate interests override the
          interests or rights and freedoms of affected individuals. These
          interests may include but are not limited to: Protecting ourselves and
          our users, and preventing spam.
        </li>
        <li>
          <strong>Consent</strong>: Where required by law, and in some other
          cases, we handle personal data on the basis of your implied or express
          consent.
        </li>
        <li>
          <strong>Legal Requirements</strong>: We need to use and disclose
          personal data in certain ways to comply with our legal obligations.
        </li>
      </ul>
      <br />
      <Heading size="lg">Disclosure of Your Information</Heading>
      <br />
      <Text>
        While we have no intention of giving your personal data to Mark
        Zuckerberg, in certain circumstances we may share your information with
        third parties, as set forth below.
      </Text>
      <br />
      <ul>
        <li>
          <strong>Business Transfers</strong>: In the event of a corporate sale,
          merger, reorganization, bankruptcy, dissolution or etc., your
          information may be part of the transferred assets.
        </li>
        <li>
          <strong>Consent</strong>: We may transfer your information with your
          consent.
        </li>
        <li>
          <strong>Agents and Related Third Parties</strong>: We enlist the help
          of other entities to perform certain tasks related to this site, such
          as: Data Storage, Error Tracking and Reporting, and Hosting.
        </li>
      </ul>
      <br />
      <Heading size="lg">Our Partners</Heading>
      <br />
      <ul>
        <li>
          <strong>Cloudflare, Inc. (San Francisco, CA)</strong>: Hosting and
          data storage provider.
        </li>
        <li>
          <strong>Google, LLC. (Mountain View, CA)</strong>: Push notifications
          (if you use the app).
        </li>
        <li>
          <strong>Mailgun Technologies, Inc. (San Antonio, TX)</strong>: Email
          solutions.
        </li>
      </ul>
      <br />
      <Heading size="lg">Security</Heading>
      <br />
      <Text>
        We take reasonable steps to protect the information provided via the
        Services from loss, misuse, and unauthorized access, disclosure,
        alteration, or destruction. However, no Internet or email transmission
        is ever fully secure or error free. In particular, email sent to or from
        the Services may not be secure. Therefore, you should take special care
        in deciding what information you send to us via email or forms. Please
        keep this in mind when disclosing any information via the Internet.
      </Text>
      <br />
      <Heading size="lg">Cookies</Heading>
      <br />
      <Text>
        All cookies by this site are necessary for the site to function. We do
        not set any marketing or tracking cookies.
      </Text>
      <br />
      <Heading size="lg">Children</Heading>
      <br />
      <Text>
        Our services are meant for users who meet or exceed the age of digital
        consent under relevant laws (such as COPPA and GDPR).
      </Text>
      <br />
      <Heading size="lg">Links to Other Websites</Heading>
      <br />
      <Text>
        This privacy policy only applies to this site and not other sites.
      </Text>
      <br />
      <Heading size="lg">Data Retention</Heading>
      <br />
      <Text>
        All data is retained as stated in the section below and is necessary to
        conduct operations.
      </Text>
      <br />
      <Heading size="lg">Data Retention Periods</Heading>
      <br />
      <ul>
        <li>
          <strong>Session Data</strong>: Until the session is considered to be
          expired (up to a week of no use but may be shorter).
        </li>
        <li>
          <strong>Email Addresses</strong>: From the time that you submit a form
          to the time that it is marked as closed (i.e when your appeal is
          reviewed).
        </li>
        <li>
          <strong>Profile, Server, and Permission Data</strong>: See the Session
          Data entry.
        </li>
        <li>
          <strong>Error Reports</strong>: Error reports collected by Sentry are
          deleted after 90 days.
        </li>
        <li>
          <strong>Uploaded Files and Report Submissions</strong>: Report
          submissions and uploaded media as part of a report submission may be
          retained indefinitely. Email addresses are removed after report
          review.
        </li>
        <li>
          <strong>Appeals</strong>: Appeal submissions are retained for 3 years
          after closure date.
        </li>
      </ul>
      <br />
      <Heading size="lg">Data Rights and Choices</Heading>
      <br />
      <Text>You have the right to:</Text>
      <br />
      <ul>
        <li>
          Access your personal information (or export it in a portable format)
        </li>
        <li>Delete your personal information</li>
        <li>
          Request restrictions on the processing of your personal information
        </li>
        <li>Lodge a complaint with a supervisory authority</li>
      </ul>
      <br />
      <Text>
        Some information as specified in the Data Retention section may be
        retained even after deleting your data. The rights and options listed
        above are subject to limitations based on applicable law.
      </Text>
      <br />
      <Heading size="lg">Contact Us</Heading>
      <br />
      <Text>
        By Email:{" "}
        <Link color="#646cff" href="mailto:r@regalijan.com">
          privacy@ccdiscussion.com
        </Link>
      </Text>
      <br />
      <Text>
        Discord:{" "}
        <Link
          color="#646cff"
          href="https://discord.com/invite/carcrushers"
          target="_blank"
        >
          https://discord.com/invite/carcrushers
        </Link>
      </Text>
    </Container>
  );
}
